import { useThemeQueries } from "views/theme"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { DialogVisualizarTermosProps } from "./dialog-visualizar-termos-props"
import { Button, Grid } from "@material-ui/core"
import { useStyles } from "./dialog-visualizar-termos-styles"
import parse from 'html-react-parser';
import { CancelarIcon } from "views/components/icons"
import { useGetPoliticaHistorico } from "data/api/gestao/politica/get-politica-historico"
import { useCallback, useEffect, useState, useRef } from "react"
import { PoliticaHistoricoModel } from "model/api/gestao/politica/politica-historico-model"
import { useCadastros } from "services/app"

import { CircularLoading } from "views/components/utils"
import { Skeleton } from "@material-ui/lab"
import { ImpressoraIcon } from "views/components/icons/impressora-icon"

export const DialogVisualizarTermos = ({ openned }: DialogVisualizarTermosProps) => {
    const { isMobile, theme } = useThemeQueries()
    const classes = useStyles()
    const { getPoliticaHistorico, carregando: carregandoPoliticaHistorico } = useGetPoliticaHistorico()
    const { fecharDialogTermosAceitos } = useCadastros()
    const termosRef = useRef<HTMLDivElement>(null)

    const carregando = carregandoPoliticaHistorico

    const [politicaHistorico, setPoliticaHistorico] = useState<PoliticaHistoricoModel | null>(null)

    const handleGetPoliticaHistorico = useCallback(async () => {
        try {
            const response = await getPoliticaHistorico()
            if (response.erro) throw response.erro
            const resultado = response.resultado?.data as PoliticaHistoricoModel | null
            setPoliticaHistorico(resultado)
        } catch (error) {
            console.error("Erro ao obter histórico de política:", error)
        }
    }, [getPoliticaHistorico])

    const handleImprimirTermos = useCallback(() => {
        if (!politicaHistorico?.termoFinal) return

        // Adicionar estilo CSS para impressão
        const printStyle = document.createElement('style')
        printStyle.id = 'print-style-temp'
        printStyle.innerHTML = `
            @media print {
                /* Ocultar tudo exceto o conteúdo dos termos */
                body * {
                    visibility: hidden;
                }
                
                /* Mostrar apenas a div dos termos e seus filhos */
                .termos-para-impressao,
                .termos-para-impressao * {
                    visibility: visible;
                }
                
                /* Posicionar o conteúdo para impressão */
                .termos-para-impressao {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    font-family: Arial, sans-serif;
                    line-height: 1.6;
                }
            }
        `
        document.head.appendChild(printStyle)

        // Adicionar classe ao elemento que contém os termos
        const termosElement = termosRef.current
        if (termosElement) {
            termosElement.classList.add('termos-para-impressao')
        }

        // Imprimir
        window.print()

        // Limpar após a impressão
        setTimeout(() => {
            if (termosElement) {
                termosElement.classList.remove('termos-para-impressao')
            }
            const styleElement = document.getElementById('print-style-temp')
            if (styleElement) {
                styleElement.remove()
            }
        }, 100)
    }, [politicaHistorico])

    useEffect(() => {
        handleGetPoliticaHistorico()
    }, [handleGetPoliticaHistorico])

    return (

        <DialogSaurus
            aberto={openned}
            titulo="Visualizar Contrato de Parceria Comercial"
            tamanho='md'
            centralizarTitulo
            colorTitulo={theme.palette.primary.main}
            fullScreen={isMobile}
            fullHeight
        >
            <div className={classes.contentCenter}>
                {carregando && <CircularLoading tipo="FULLSIZED" />}
                <Grid container spacing={2} justifyContent="center" className={classes.overflowHidden}>
                    <Grid xs={12} item className={classes.termosDeUso}>
                        <div ref={termosRef}>
                            {carregandoPoliticaHistorico ? (
                                <>
                                    <Skeleton height={60} width={500} />
                                    <Skeleton height={500} />
                                    <Skeleton height={60} width={500} />
                                    <Skeleton height={500} />
                                </>
                            ) :
                                parse(politicaHistorico?.termoFinal || '')
                            }
                        </div>
                    </Grid>
                    <Grid container spacing={2} xs={12} className={classes.buttonSpace}>
                        <Grid item xs={6} >
                            <Button
                                type="submit"
                                color="primary"
                                variant="outlined"
                                fullWidth={true}
                                size="large"
                                disabled={carregando}
                                onClick={() => {
                                    fecharDialogTermosAceitos()
                                }}
                            >
                                <CancelarIcon
                                    fill={theme.palette.primary.main}
                                    tipo="BUTTON"
                                />
                                Fechar
                            </Button>
                        </Grid>
                        <Grid item xs={6} >
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                size="large"
                                fullWidth={true}
                                disabled={carregando || !politicaHistorico}
                                onClick={handleImprimirTermos}
                            >
                                <ImpressoraIcon tipo="BUTTON_PRIMARY" />
                                Imprimir
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </DialogSaurus>
    )
}